import { useContext } from 'react'

import {
  SmartSearchContext,
  type SmartSearchContextValue,
} from '../Contexts/SmartSearchContext'

export const useSmartSearch = (): SmartSearchContextValue => {
  const ctx = useContext(SmartSearchContext)
  if (!ctx) {
    throw new Error('useSmartSearch must be used within a SmartSearchProvider')
  }
  return ctx
}
